"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderSceneOnCanvas = exports.sceneToDataUrl = void 0;
var realms_three_1 = __importDefault(require("realms-three"));
/**
 * Global scene utils
 */
var GlobalSceneUtils = /** @class */ (function () {
    function GlobalSceneUtils() {
    }
    GlobalSceneUtils.get = function () {
        if (!GlobalSceneUtils.canvas) {
            GlobalSceneUtils.canvas = document.createElement("canvas");
        }
        if (!GlobalSceneUtils.renderer) {
            GlobalSceneUtils.renderer = new realms_three_1.default.WebGLRenderer({
                canvas: GlobalSceneUtils.canvas,
            });
        }
        if (!GlobalSceneUtils.effectComposer) {
            GlobalSceneUtils.effectComposer = new realms_three_1.default.STDLIB.EffectComposer(GlobalSceneUtils.renderer);
        }
        if (!GlobalSceneUtils.renderPass) {
            // Fill with empty scene and camera and change on runtime
            GlobalSceneUtils.renderPass = new realms_three_1.default.STDLIB.RenderPass(new realms_three_1.default.Scene(), new realms_three_1.default.PerspectiveCamera());
            GlobalSceneUtils.effectComposer.addPass(GlobalSceneUtils.renderPass);
        }
        if (!GlobalSceneUtils.gammaCorrectionPass) {
            GlobalSceneUtils.gammaCorrectionPass = new realms_three_1.default.STDLIB.ShaderPass(realms_three_1.default.STDLIB.GammaCorrectionShader);
            GlobalSceneUtils.effectComposer.addPass(GlobalSceneUtils.gammaCorrectionPass);
        }
        if (!GlobalSceneUtils.antialiasPass) {
            GlobalSceneUtils.antialiasPass = new realms_three_1.default.STDLIB.ShaderPass(realms_three_1.default.STDLIB.FXAAShader);
            GlobalSceneUtils.effectComposer.addPass(GlobalSceneUtils.antialiasPass);
        }
        return {
            canvas: GlobalSceneUtils.canvas,
            renderer: GlobalSceneUtils.renderer,
            effectComposer: GlobalSceneUtils.effectComposer,
            renderPass: GlobalSceneUtils.renderPass,
            antialiasPass: GlobalSceneUtils.antialiasPass,
        };
    };
    GlobalSceneUtils.render = function (_a) {
        var _b;
        var scene = _a.scene, camera = _a.camera, width = _a.width, height = _a.height, beforeRender = _a.beforeRender, alpha = _a.alpha, passes = _a.passes;
        var _c = GlobalSceneUtils.get(), canvas = _c.canvas, renderer = _c.renderer, effectComposer = _c.effectComposer, renderPass = _c.renderPass, antialiasPass = _c.antialiasPass;
        // Update render pass
        renderPass.scene = scene;
        renderPass.camera = camera;
        // Add passes
        for (var _i = 0, _d = passes !== null && passes !== void 0 ? passes : []; _i < _d.length; _i++) {
            var pass = _d[_i];
            effectComposer.addPass(pass);
        }
        camera.updateMatrix();
        var pixelRatio = window.devicePixelRatio;
        // Create Canvas
        canvas.width = width;
        canvas.height = height;
        (_b = antialiasPass.uniforms["resolution"]) === null || _b === void 0 ? void 0 : _b.value.set(1 / (width * pixelRatio), 1 / (height * pixelRatio));
        // Set pixel ratio
        renderer.setPixelRatio(pixelRatio);
        effectComposer.setPixelRatio(pixelRatio);
        renderer.setViewport(0, 0, width, height);
        renderer.setClearAlpha(alpha ? 0 : 1);
        // Set size
        renderer.setSize(width, height);
        renderPass.setSize(width, height);
        effectComposer.setSize(width, height);
        // Before render actions
        if (beforeRender) {
            beforeRender({ renderer: renderer });
        }
        // Render scene
        effectComposer.render();
        // Remove passes
        for (var _e = 0, _f = passes !== null && passes !== void 0 ? passes : []; _e < _f.length; _e++) {
            var pass = _f[_e];
            effectComposer.removePass(pass);
        }
        return canvas;
    };
    GlobalSceneUtils.canvas = null;
    GlobalSceneUtils.renderer = null;
    GlobalSceneUtils.effectComposer = null;
    GlobalSceneUtils.renderPass = null;
    // Fixes the blurry issue of render pass
    GlobalSceneUtils.antialiasPass = null;
    // Fixes weird coloring
    GlobalSceneUtils.gammaCorrectionPass = null;
    return GlobalSceneUtils;
}());
/**
 * Renders a scene and returns it as a dataurl
 */
function sceneToDataUrl(renderProps) {
    var canvas = GlobalSceneUtils.render(renderProps);
    return canvas.toDataURL();
}
exports.sceneToDataUrl = sceneToDataUrl;
/**
 * Renders a scene onto a canvas
 */
function renderSceneOnCanvas(_a) {
    var targetContext = _a.targetContext, renderProps = __rest(_a, ["targetContext"]);
    var canvas = GlobalSceneUtils.render(renderProps);
    // Render scene
    var oldSmoothingValue = targetContext.imageSmoothingEnabled;
    targetContext.imageSmoothingEnabled = false;
    targetContext.clearRect(0, 0, renderProps.width * window.devicePixelRatio, renderProps.height * window.devicePixelRatio);
    targetContext.drawImage(canvas, 0, 0, renderProps.width * window.devicePixelRatio, renderProps.height * window.devicePixelRatio);
    targetContext.imageSmoothingEnabled = oldSmoothingValue;
}
exports.renderSceneOnCanvas = renderSceneOnCanvas;
